import * as React from "react";
import { getDictPhrase, getGameStateAdditionalData } from "../../../../helpers";
import GameStateGameInfo from "./GameStateGameInfo";
import GameStateAdditionalData from "./GameStateAdditionalData";
export const GameState = (props) => {
    let additionalData;
    let text;
    let gameTime;
    if (props.details.event.isLive) {
        additionalData = getGameStateAdditionalData(props.details);
        text = getDictPhrase(props.details.dict, props.details.event.gamePart);
        gameTime = props.details.event.gameTime ? props.details.dict.ClockMins.format(props.details.event.gameTime) : "";
    }
    return (props.details.event.isLive
        ? React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__game-state`, "data-uat": `div-ev-list-${props.componentPrefix}-game-state` },
            React.createElement(GameStateGameInfo, { componentPrefix: props.componentPrefix, text: text, gameTime: gameTime }),
            additionalData
                ? React.createElement(GameStateAdditionalData, Object.assign({}, additionalData))
                : React.createElement(React.Fragment, null))
        : React.createElement(React.Fragment, null));
};
//# sourceMappingURL=GameState.js.map